import { useMsal } from "@azure/msal-react";
import { useMemo } from "react";


export const AccessToken = () => {    
    
    const { instance, accounts } = useMsal();
    const primaryAccount = accounts?.[0];
    
    const accessTokenRequest:any = useMemo(() => {
        return {
            scopes: [process.env.REACT_APP_SCOPE],
            account: primaryAccount,
        };
    }, [
        primaryAccount?.homeAccountId,
        primaryAccount?.localAccountId,
        primaryAccount?.username,
        primaryAccount?.tenantId,
    ]);
    
    return useMemo(() => [instance, accessTokenRequest], [instance, accessTokenRequest]);
}
